export const cartApi = args => {
  const method = args.method || 'POST';
  const headers = new window.Headers();
  const credentials = 'include';
  const mode = 'cors';

  const url = args.endpointUrl;
  const body = JSON.stringify(args.body);

  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');

  const options = {
    headers,
    method,
    credentials,
    mode,
    body
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return response.error();
    })
    .then(json => json)
    .catch(error => {
      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/api/cartApi.js